"use client";

import axios from "axios";
import { toast } from "react-toastify";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { id } from "yup-locales";

export const api = process.env.NEXT_PUBLIC_BASE_API;
export const server = axios.create();
server.defaults.baseURL = process.env.NEXT_PUBLIC_BASE_API;

export const GavelLogin = async (ReservationNumber = null, Emlak = null) => {
  return server.post(
    "/CheckGavelReservation",
    "ReservationNumber=" + ReservationNumber + "&emlak=" + Emlak
  );
};

export const useGetSearchBoxDataTip = (tableType) => {
  const { data, error, trigger } = useSWRMutation(
    `${api}/GetSearchBoxData?table=${tableType}`
  );
  return { data, error, trigger };
};
export const useGetAllVillas = (debouncedSearch) => {
  const { data, error, isLoading } = useSWR(
    `${api}/Search?q=${debouncedSearch}`
  );
  return { data, error, isLoading };
};

export const useGetVillasByVitrin = (vitrin) => {
  const { data, error, isLoading } = useSWR(
    api + "/GetVillasByKey?key=" + vitrin
  );
  return { data, error, isLoading };
};

export const useGetVillasHomeShortTerms = () => {
  const { data, error, isLoading } = useSWR(api + "/HomeShortTerms");
  return { data, error, isLoading };
};

export const useGetVillasComingChances = (EntityId = null) => {
  const { data, error, isLoading, mutate } = useSWR(
    api + "/LastMinute" + (EntityId ? "?EntityId=" + EntityId : "")
  );
  return { data, error, isLoading, mutate };
};

export const useGetDiscountedVillas = () => {
  const { data, error, isLoading, mutate } = useSWR(
    api + "/DiscountedVillas"
  );
  return { data, error, isLoading, mutate };
};


export const useGetHomeReviews = () => {
  const { data, error, isLoading } = useSWR(api + "/HomeReviews");
  return { data, error, isLoading };
};

export const useGetSleepingPlan = (estateId) => {
  const { data, error, isLoading } = useSWR(
    `${api}/GetSleepPlan?estateId=${estateId}`
  );
  return { data, error, isLoading };
};

export const useGetAvailability = (EntityId) => {
  const { data, error, isLoading } = useSWR(
    EntityId ? `${api}/Availability?EntityId=${EntityId}` : ""
  );
  return { data, error, isLoading };
};

export const useGetHeaderData = () => {
  const { data, error, isLoading } = useSWR(
    `${api}/header`
  );
  return { data, error, isLoading };
};

export const useGetFooterData = () => {
  const { data, error, isLoading } = useSWR(`${api}/FooterMenu`);
  return { data, error, isLoading };
};

export const GetAvailability = async (EntityId) => {
  if (EntityId == 1) {
    return { data: { data: [] } };
  }
  return server.get(`/Availability?EntityId=${EntityId}`);
};

export const GetAvailableReservations = async (data) => {
  let form_data = new FormData();

  Object.keys(data).forEach((key) => form_data.append(key, data[key]));

  return server.post("/KiralamaTakvimi/AvailableReservations", form_data);
};

export const useGetPriceList = (id, currency) => {
  const { data, error, isLoading } = useSWR(
    `${api}/PriceList?id=${id}&currency=${currency}`
  );
  return { data, error, isLoading };
};

export const GetDistance = async (id) => {
  return server.get("/Distance?EntityId=" + id);
};

export const useGetReviews = (id) => {
  const { data, error, isLoading } = useSWR(api + "/Reviews?EntityId=" + id);
  return { data, error, isLoading };
};

export const FilterApi = async (params) => {
  const strParams = new URLSearchParams(params).toString();
  return server.get(`/filter?${strParams}&limit=10`);
};

export const Calculate = async (params) => {
  const strParams = new URLSearchParams(params).toString();
  return server.get("/Calculate?" + strParams);
};
export const SendOffer = async (data) => {
  return server.post("/SendOffer", "data=" + JSON.stringify(data));
};
export const Whatsapp = async () => {
  return server.get("/Whatsapp");
};

export const SendReservation = async (params, data) => {
  let form_data = new FormData();

  Object.keys(data).forEach((key) => form_data.append(key, data[key]));

  const strParams = new URLSearchParams(params).toString();

  return server.post("/SendReservation?" + strParams, form_data);
};

export const fetchVillas = async (params, addDays = 0, data) => {
  try {
    const response = await FilterApi({
      page: params.page || 1,
      CurrentRoutingTypeId: data.RoutingTypeId,
      EntityId: data.EntityId,
      searchdate1: params.start || "",
      searchdate2: params.end || "",
      bolge: params.bolge || "",
      specy: params.specy || "",
      tip: params.tip || "",
      yetiskin: params.yetiskin || 0,
      cocuk: params.cocuk || 0,
      takvimkurali: params.takvimkurali || 0,
      order_by: params.order_by || 0,
      ay: params.ay || 0,
      gece: params.gece || 0,
      min: params.min || "",
      max: params.max || "",
      showall: data?.result?.ShowTopSearchBar == "0" ? 1 : 0,
      ids: params.ids || "",
      search: params.search || "",
      customList: data.pageId?.CustomList?.PageId || 0,
      disableCalendarRules: params.disableCalendarRules || 0,
      addDays,
      showMinMaxPrice: params.showMinMaxPrice || 0,
    });
    return response.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const AuthMyReservations = async (Action = "Reservations") => {
  if (localStorage.getItem("reservations_auth"))
    return server.post(
      "/IsLogin?Action=" + Action,
      "token=" + localStorage.getItem("reservations_auth")
    );

  throw { error: "Not Login" };
};

export const AuthLogin = async (
  Email = null,
  ReservationNumber = null,
  AuthKey = null
) => {
  if (AuthKey) return server.post("/Reservations", "AuthKey=" + AuthKey);
  return server.post(
    "/Reservations",
    "Email=" + Email + "&ReservationNumber=" + ReservationNumber
  );
};

export const AuthLogout = async () => {
  return server.post(
    "/Logout",
    "token=" + localStorage.getItem("reservations_auth")
  );
};

export const GetReservations = async (token) => {
  return server.get("/Reservations?token=" + token);
};

export const GetPaymentData = async (token, id, agent = null, ip = null) => {
  const config = {};
  if (agent) {
    config.headers = {
      "User-Agent": agent,
      CLIENT_IP: ip,
    };
  }
  return server.post("/Payment?token=" + token, "id=" + id, config);
};

export const SaveBankTransferForm = async (token, id, data) => {
  return server.post(
    "/SaveBankTransferForm?token=" + token + "&_=" + id,
    "data=" + JSON.stringify(data)
  );
};

export const GetPassengerInformation = async (token, id) => {
  return server.get("/PassengerInformation?token=" + token + "&_=" + id);
};

export const SavePassengerInformation = async (token, id, data) => {
  return server.post(
    "/PassengerInformation?token=" + token + "&_=" + id,
    "data=" + JSON.stringify(data)
  );
};
export const SaveNewComment = async (data, id) => {
  let form_data = new FormData();
  Object.keys(data).forEach((key) => form_data.append(key, data[key]));

  return server.post(
    "/Reviews?id=" + id,
    form_data
  );
};
